import { AddEditeVotingBasicSetting, AddEditeVotingCandidateInformation, GetAlleVotingCandidateList, GeteVotingBasicSettingByAdminId, EvotingAdminLogin, DeleteCandidate, ExportExcelForVotingReport, ExportExcelForVotingDetailsReport, ExportElectionResultsReport, ExportElectionVotedInReport } from "../ApiEndPoints";
import { axiosGetAuthorize, axiosPostAuthorize, axiosPostFileAuthorizeblob } from "../AxiosRequests";

export default class eVotingServices {
    async geteVotingBasicSettingByAdminId(request) {
        return axiosGetAuthorize(GeteVotingBasicSettingByAdminId, request);
    }
    async addEditeVotingBasicSetting(request) {
        return axiosPostAuthorize(AddEditeVotingBasicSetting, request);
    }
    async getAllCandidateList(request) {
        return axiosGetAuthorize(GetAlleVotingCandidateList, request);
    }
    async addEditCandidateInformation(request) {
        return axiosPostAuthorize(AddEditeVotingCandidateInformation, request);
    }
    async deleteCandidate(request) {
        return axiosPostAuthorize(DeleteCandidate, request);
    }
    async loginAdmin(request) {
        return axiosPostAuthorize(EvotingAdminLogin, request);
    }
    async exportExcelForVotingReport(request) {
        return axiosPostFileAuthorizeblob(ExportExcelForVotingReport, request);
    }
    async exportElectionResultsReport(request) {
        return axiosPostFileAuthorizeblob(ExportElectionResultsReport, request);
    }
    async exportElectionVotedInReport(request) {
        return axiosPostFileAuthorizeblob(ExportElectionVotedInReport, request);
    }
}